import isToday from 'date-fns/isToday';
import isYesterday from 'date-fns/isYesterday';
import format from 'date-fns/format';

/**
 * Formats a date into a human-readable string in German.
 * - Today: "Heute HH:mm"
 * - Yesterday: "Gestern HH:mm"
 * - Other dates: "dd.MM.yyyy HH:mm"
 *
 * @param date - The date to format
 * @returns Formatted date string
 * @throws Error if date is invalid
 */
export const formatDateWithRelativeTime = (date: Date): string => {
  if (!(date instanceof Date) || isNaN(date.getTime())) {
    return '';
  }

  if (isToday(date)) {
    return `Heute ${format(date, 'HH:mm')}`;
  }

  if (isYesterday(date)) {
    return `Gestern ${format(date, 'HH:mm')}`;
  }

  return format(date, 'dd.MM.yyyy HH:mm');
};
